export default function IconMultiple() {
  return (
    <svg aria-hidden="true" focusable="false" height="100%" viewBox="0 0 24 24" width="100%">
      <g fill="#000000">
        <path d="M20 6h2a2 2 0 012 2v14a2 2 0 01-2 2H8a2 2 0 01-2-2v-2h12a2 2 0 002-2V6zM2 0h14a2 2 0 012 2v14a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z" />
      </g>
    </svg>
  )
}
